"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M14 2H2v12h2V4h10zm4 4H6v12h2V8h10zm4 4H10v12h12z"
}), 'AutoAwesomeMotionSharp');